import { AppLayout } from '../../../components/AppLayout'
import { TerminationRequestsList } from '../components/TerminationRequestsList'

export function TerminationRequestsPage() {
  return (
    <AppLayout>
      <TerminationRequestsList />
    </AppLayout>
  )
}
